export default __webpack_public_path__ + "static/media/camara.478fb21f.png";